import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"

import GuestLayout from "../components/GuestLayout"

import * as cartSlice from "../store/cart"
import { getSrc } from "../utilities/enumerations/constants"

const Cart = () => {
  const dispatch = useDispatch()
  const cartState = useSelector((state) => state.cart)

  const handleDecrement = async (item) => {
    dispatch(cartSlice.handleCartDecrement(item.slug))
  }

  const handleIncrement = async (item) => {
    if (cartState.cartById[item.slug] >= 5) return alert('For more than 5 quantity please contact our support on whatsapp')
    dispatch(cartSlice.handleCartIncrement(item.slug))
  }

  const handleEmptyCart = () => {
    dispatch(cartSlice.emptyCart())
  }

  const subTotal = cartState.cart.reduce((p, c) => p += c.price * cartState.cartById[c.slug], 0)
  const dealDiscount = cartState.cart.reduce((p, c) => p += c.discount * cartState.cartById[c.slug] || 0, 0)
  const total = subTotal - dealDiscount

  if (!cartState.cart.length) return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <div className="container">
        <section className="py-3">
          <p className="lead text-body-emphasis fw-bold">Cart</p>
          <div className="card rounded-4 shadow-none my-3 text-center">
            <div className="card-body p-5">
              <div className="d-flex flex-column gap-3 align-items-center">
                <p className="display-1 text-body-tertiary m-0"><i className="bi bi-bag-x"></i></p>
                <p className="lead text-body-tertiary fw-semibold m-0">No deals or products selected</p>
                <Link to="/#deals" className="btn btn-light-theme rounded-3">Explore Products</Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </GuestLayout>
  )

  return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <div className="container">
        <section className="py-3">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-body-emphasis fw-bold m-0">Cart</h3>
            {!!cartState.cart.length && <button className="btn btn-light-danger rounded-4" onClick={handleEmptyCart}>Empty Cart</button>}
          </div>
          {!!cartState.cart.length && <div className="row g-3 pt-3">
            <div className="col-md-8">
              <div className="d-flex flex-column">
                {cartState.cart.map((item, index) => {
                  let border = ''
                  if (index === 0) border = 'border-top rounded-top-4'
                  else if (index === cartState.cart.length - 1) border = 'rounded-bottom-4'

                  const price = item.price - (item.discount || 0)

                  return (
                    <div key={`cart-item-${index}`} className={`card border-top${index !== 0 && '-0'} rounded-${cartState.cart.length === 1 ? '4' : '0'} ${border} shadow-none`}>
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-center gap-3">
                          <img src={getSrc(item.thumbnail_url)} alt={item.title} className="border rounded-3" width={48} height={48} />
                          <div className="flex-grow-1">
                            <p className="small text-body-emphasis fw-bold m-0">{item.title}</p>
                            <p className="text-body-tertiary fw-bold m-0">Rs. {price.toFixed(2)}</p>
                          </div>
                          <div className="d-flex gap-3 justify-content-between align-items-center">
                            <button type="button" className="btn btn-sm btn-light-danger rounded-3 flex-grow-1" onClick={() => handleDecrement(item)}><i className="bi bi-dash-lg"></i></button>
                            <p className="flex-grow-1 text-body-tertiary fw-bold m-0">{cartState.cartById[item.slug]}</p>
                            <button type="button" className="btn btn-sm btn-light-theme rounded-3 flex-grow-1" onClick={() => handleIncrement(item)}><i className="bi bi-plus-lg"></i></button>
                          </div>
                          <p className="text-body-tertiary fw-bold m-0">Rs. {(cartState.cartById[item.slug] * price).toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="col-md-4">
              <div className="border border-bottom-0 rounded-top-4 p-3">
                <p className="lead text-body-emphasis fw-bold mb-3">Summary</p>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <p className="text-body-tertiary fw-bold m-0">Sub Total</p>
                  <p className="text-body-tertiary fw-bold m-0">Rs. {subTotal.toFixed(2)}</p>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <p className="text-body-tertiary fw-bold m-0">Deal Discount</p>
                  <p className="text-body-tertiary fw-bold m-0">Rs. {dealDiscount.toFixed(2)}</p>
                </div>
              </div>
              <div className="bg-light border p-3 rounded-bottom-4 mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="text-body-secondary fw-bold m-0">Total</p>
                  <p className="text-body-secondary fw-bold m-0">Rs. {total.toFixed(2)}</p>
                </div>
              </div>
              <Link to="/checkout" className="btn btn-theme w-100 rounded-4">Continue to Checkout</Link>
            </div>
          </div>}
        </section>
      </div>
    </GuestLayout>
  )
}

export default Cart